import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import EventTypes from "../shared/EventTypes";
import { TIP_BAR_HEIGHT } from "../shared/constants";

export default class ZoomMenu extends AbstractProvidedClass {
    init() {
        this.container = this.p.createDiv().parent('#p5canvas');
        this.position();

        // Zoom in
        const zoomInBtn = this.p.createButton('<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#zoom-in-line"></use></svg>')
            .parent(this.container)
            .class('btn-icon-bright')
            .attribute('title', 'Zoom in');
        zoomInBtn.elt.addEventListener('click', () => this.view.zoomIn());
        zoomInBtn.elt.addEventListener('touchend', (e) => {
            e.preventDefault();
            this.view.zoomIn();
            zoomInBtn.elt.blur();
        }, { passive: false });

        // Zoom out
        const zoomOutBtn = this.p.createButton('<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#zoom-out-line"></use></svg>')
            .parent(this.container)
            .position(0, 40)
            .class('btn-icon-bright')
            .attribute('title', 'Zoom out');
        zoomOutBtn.elt.addEventListener('click', () => this.view.zoomOut());
        zoomOutBtn.elt.addEventListener('touchend', (e) => {
            e.preventDefault();
            this.view.zoomOut();
            zoomOutBtn.elt.blur();
        }, { passive: false });

        this.on(EventTypes.OPEN_SIDEBAR, () => this.position());
        this.on(EventTypes.CLOSE_SIDEBAR, () => this.position());
    }

    position() {
        this.x = 10;
        this.y = this.p.height - (125 + (this.editMode ? TIP_BAR_HEIGHT : 0));
        this.container.position(this.x, this.y);
    }

    hovered() {
        return this.p.mouseX > this.x
            && this.p.mouseX < this.x + 40
            && this.p.mouseY > this.y
            && this.p.mouseY < this.y + 83;
    }
}
